import Durations from "@/models/Durations";

const state = {
  typeAlert: "",
  messageAlert: "",
  messagesArray: [],
  errorBackend: [],
};

const getters = {
  typeAlert: (state) => state.typeAlert,
  messageAlert: (state) => state.messageAlert,
  getErrorBackend: (state) => state.errorBackend,
  getMessagesArray: (state) => state.messagesArray,
};

const mutations = {
  SET_NOTIFICATION(state, { typeAlert, messageAlert }) {
    state.typeAlert = typeAlert;
    state.messageAlert = messageAlert;
  },
  SET_NOTIFICATION_MESSAGE_ARRAY(state, { typeAlert, messageAlert }) {
    state.messagesArray.push({ type: typeAlert, message: messageAlert });
  },
  SET_ERROR_BACK(state, payload) {
    state.errorBackend = payload;
  },
  NEW_ERROR_BACK(state, payload) {
    state.errorBackend.push(payload);
  },
};

const actions = {
  /**
   * This method shows a toaster when it is called. It takes as a paramater an Object with inside a messageAlert and a typeAlert.
   * The messageAlert can be for instance 'user deleted !'.
   * The typeAlert comes from Vuetify class (https://vuetifyjs.com/en/components/alerts/#usage). For instance it can be 'error' to  have red toaster or 'success' to have a green toaster.
   *
   * @param  {Vuex} {commit} necessary if call commit inside the method
   * @param  {Object} payload { messageAlert: String, typeAlert: String }
   */
  async showNotification({ commit }, payload) {
    commit("SET_NOTIFICATION", payload);
    commit("SET_NOTIFICATION_MESSAGE_ARRAY", payload);
    return new Promise((resolve) => {
      const timeout = setTimeout(
        () => {
          clearTimeout(timeout);
          commit("SET_NOTIFICATION", {
            typeAlert: "",
            messageAlert: "",
          });
          state.messagesArray.shift();
          resolve();
        },
        payload.duration ? payload.duration : Durations.DefaultNotification
      );
    });
  },
  /**
   * This method is used to show error messages from the Back-End.
   *
   * @param  {Vuex} {commit} necessary if call commit inside the method
   * @param  {String} errors error message we want to display in the Front-End
   */
  async showErrorMessages({ commit }, errors) {
    commit("NEW_ERROR_BACK", errors);
  },
  /**
   * This method is used to empty the variable errorBackend
   *
   * @param  {Vuex} {commit} necessary if call commit inside the method
   */
  async emptyErrorMessages({ commit }) {
    let errors = [];
    commit("SET_ERROR_BACK", errors);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
